<template>
  <div>
    <header3></header3>
    <project-info :projectId="parseInt($route.query.projectId)" :trainingId="parseInt($route.query.trainingId)"></project-info>
    <footer1></footer1>
  </div>
</template>

<script>
  import  header3 from '../../components/Header3'
  import  footer1 from '../../components/Footer1'
  import projectInfo from '../../components/ProjectInfo'
  export default {
    components: {
      header3,
      footer1,
      projectInfo
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/usercenter/ProjectDetail.vue